import React, { PropTypes } from 'react'

import './LocationInput.scss'
import Geosuggest from 'components/Geosuggest'

const LocationInput = (props) => {
  const {
    input: {
      value: location,
      onChange,
      onFocus,
      onBlur
    },
    meta: {
      touched,
      error
    }
  } = props

  return (
    <div className='LocationInput'>
      <div className='LocationInput-geosuggest'>
        <Geosuggest
          initialLocation={location}
          placeholder='Escribe tu colonia'
          ignoreTab
          onSuggestSelect={onChange}
          onFocus={onFocus}
          onBlur={() => {
            onBlur(location)
          }}
          autoActivateFirstSuggest
          />
      </div>
      <div className='LocationInput-error'>
        {
          touched && error && <p>{error}</p>
        }
      </div>
    </div>
  )
}
LocationInput.displayName = 'LocationInput'
LocationInput.propTypes = {
  input: PropTypes.shape({
    value: PropTypes.shape({
      label: PropTypes.string,
      placeId: PropTypes.string
    }),
    onChange: PropTypes.func.isRequired
  }).isRequired,
  meta: PropTypes.shape({
    touched: PropTypes.bool,
    error: PropTypes.string
  }).isRequired
}
LocationInput.defaultProps = {
  input: {
    value: {
      label: '',
      placeId: ''
    }
  }
}

export default LocationInput



// WEBPACK FOOTER //
// ./src/screens/App/screens/Booking/screens/ServiceSetup/screens/LocationForm/components/LocationInput/LocationInput.js